import z from "zod";

/**
 * Common list response schema (message, id, ok)
 */
export const commonListItemResponseSchema = z.object({
    message: z.string(),
    id: z.string(),
    ok: z.boolean(),
});
export const commonListResponseSchema = z.array(commonListItemResponseSchema);

export type ICommonListItemResponse = z.infer<typeof commonListItemResponseSchema>;
export type ICommonListResponse = z.infer<typeof commonListResponseSchema>;
